module.exports = __webpack_public_path__ + "static/img/logo-ilog-256.1eb93fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/logo-ilog-256.png
// module id = QbZ5
// module chunks = 1